import $ from "jquery";
import "arrive";
import "slick-carousel";

$(document).ready(function () {
    document.arrive(".block-fullwidth-content-slider", {existing: true}, function () {
            $(this).find(".srg-slick-post-slider").each(function () {
                let $slider = $(this);
                let $slider_nav = $slider.prev(".block-fullwidth-content-slider-heading");
                $slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: false,
                    speed: 500,
                    fade: true,
                    cssEase: "linear",
                    responsive: [
                        {
                            breakpoint: 576,
                            settings: {
                                dots: true,
                            },
                        },
                    ],
                });
                $slider_nav
                    .find(".block-fullwidth-content-slider-arrow-right")
                    .click(function () {
                        $slider.slick("slickNext");
                    });
                $slider_nav
                    .find(".block-fullwidth-content-slider-arrow-left")
                    .click(function () {
                        $slider.slick("slickPrev");
                    });
            });
            let $heading = $(this).find(".block-fullwidth-content-slider-heading");
            let $content = $heading.find(
                ".block-fullwidth-content-slider-heading-content"
            );
            $heading.find(".icon-info").click(function () {
                $content.toggleClass("open");
            });
        }
    );
});


